import { Link } from 'react-router-dom'
import { GitBranch } from 'lucide-react'

// Mirrors apps/mobile/app/(auth)/onboarding/index.tsx — three-slide intro
// followed by a "Get Started" CTA that lands at /login. The mobile flow
// shows this on first launch; the web equivalent is reachable directly
// from /onboarding (the auth shell links to it as a marketing landing).

const SLIDES = [
  { icon: '👨‍👩‍👧‍👦', title: 'Map Your Family', desc: 'Build your family tree and discover how everyone is connected.' },
  { icon: '🌐',          title: 'Share & Connect',  desc: 'Share posts and memories with the right circles of family.' },
  { icon: '🔍',          title: 'Find Relatives',   desc: 'Discover relatives you never knew — across generations.' },
]

export function OnboardingPage() {
  return (
    <div className="min-h-full bg-navy text-white px-6 py-10 flex flex-col">
      <div className="flex items-center gap-2 mt-2">
        <GitBranch size={36} className="text-gold" />
        <span className="text-gold text-3xl font-extrabold">Jnati</span>
      </div>

      <div className="flex-1 flex flex-col justify-center gap-10 max-w-md mx-auto w-full py-10">
        {SLIDES.map((slide) => (
          <div key={slide.title} className="text-center">
            <div className="text-5xl mb-3">{slide.icon}</div>
            <h2 className="text-[22px] font-bold mb-2">{slide.title}</h2>
            <p className="text-white/65 text-[15px] leading-relaxed">{slide.desc}</p>
          </div>
        ))}
      </div>

      <Link
        to="/login"
        className="bg-gold text-navy text-center rounded-xl py-4 font-bold text-[17px] mb-4"
      >
        Get Started
      </Link>
      <p className="text-white/50 text-xs text-center">
        Already have an account?{' '}
        <Link to="/login" className="text-gold font-bold">Login</Link>
      </p>
    </div>
  )
}
